import __request__ from "routing/request";
export function current(requestOptions) {
  return __request__("GET", "/datanodes/restart", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function start(JSONbody, requestOptions) {
  return __request__("POST", "/datanodes/restart", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function abort(requestOptions) {
  return __request__("POST", "/datanodes/restart/abort", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function history(requestOptions) {
  return __request__("GET", "/datanodes/restart/history", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resume(requestOptions) {
  return __request__("POST", "/datanodes/restart/resume", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
